import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, Newspaper, Wallet, User, Settings, LogOut, ChevronRight } from 'lucide-react';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from '../ui/sheet';
import { useAuth } from '../../contexts/AuthContext';

const SheetItem = ({ icon: Icon, label, onClick, danger, testId }) => (
  <button type="button" onClick={onClick} data-testid={testId}
    className={`w-full flex items-center gap-3 px-3 py-3 rounded-xl hover:bg-slate-50 ${danger ? 'text-red-600' : 'text-slate-800'}`}>
    <Icon className="w-5 h-5" /><span className="flex-1 text-left text-sm font-medium">{label}</span>
    {!danger && <ChevronRight className="w-4 h-4 text-slate-400" />}
  </button>
);

export const MobileBottomNav = ({ active }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const isEmployee = user?.role?.toUpperCase() === 'EMPLOYEE';
  const items = [
    { id: 'inicio', label: 'Início', icon: Home, go: () => navigate(isEmployee ? '/m/employee' : '/m') },
    { id: 'feed', label: 'Feed', icon: Newspaper, go: () => navigate(isEmployee ? '/m/employee/feed' : '/m/feed') },
    { id: 'caixa', label: 'Meu Caixa', icon: Wallet, go: () => navigate('/m/caixa') },
    { id: 'perfil', label: 'Perfil', icon: User, go: () => setOpen(true) },
  ];
  return (
    <>
      <nav className="fixed bottom-0 inset-x-0 z-40 h-16 bg-white/95 backdrop-blur-md border-t border-slate-200 flex justify-around items-center"
        style={{ paddingBottom: 'env(safe-area-inset-bottom)' }} data-testid="mobile-bottom-nav">
        {items.map((n) => (
          <button key={n.id} type="button" onClick={n.go} data-testid={`bottom-nav-${n.id}`}
            className={`flex flex-col items-center gap-0.5 text-[11px] transition-colors ${active === n.id ? 'text-cyan-700 font-semibold' : 'text-slate-500'}`}>
            <n.icon className="w-5 h-5" />{n.label}
          </button>
        ))}
      </nav>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="bottom" className="rounded-t-3xl" data-testid="profile-sheet">
          <SheetHeader>
            <SheetTitle>Perfil</SheetTitle>
            <SheetDescription>{user?.email}</SheetDescription>
          </SheetHeader>
          <div className="mt-3 space-y-1 pb-4">
            <SheetItem icon={User} label="Meu Perfil" testId="sheet-meu-perfil" onClick={() => navigate(isEmployee ? '/m/employee/profile' : '/m/profile')} />
            {!isEmployee && (
              <SheetItem icon={Settings} label="Configurações" testId="sheet-configuracoes" onClick={() => navigate('/m/settings')} />
            )}
            <SheetItem icon={LogOut} label="Sair da Conta" danger testId="sheet-sair" onClick={() => { logout(); window.location.replace('/m/login'); }} />
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
};
